module.exports = __webpack_public_path__ + "img/shrimp-creole.c1d44e50.jpg";